import { EventTypes } from 'redux-segment';
import ApiService from '../util/api';
import * as ActionType from './types/UserActionTypes';

export function requestUser() {
  return {
    type: ActionType.REQUEST_USER
  };
}

export function receiveUser(response) {
  return {
    type: ActionType.RECEIVE_USER,
    payload: response
  };
}

export function requestUserStatus() {
  return {
    type: ActionType.REQUEST_USER_STATUS
  };
}

export function receiveUserStatus(response) {
  return {
    type: ActionType.RECEIVE_USER_STATUS,
    payload: response
  };
}

export function identifyUser(forceIdentify) {
  return (dispatch, getState) => {
    const userContext = getState().user.userContext || {};
    const hasIdentified = getState().user.hasIdentified;
    if (!userContext.is_guest && (!hasIdentified || forceIdentify)) {
      const meta = {
        analytics: {
          eventType: EventTypes.identify,
          eventPayload: {
            userId: userContext.object_id,
            traits: {
              email: userContext.email || '',
              first_name: userContext.first_name || '',
              last_name: userContext.last_name || '',
              role: (userContext.user_role_account_weddings && userContext.user_role_account_weddings.length > 0) ? userContext.user_role_account_weddings[0].role : '',
              name: userContext.first_name ? `${userContext.first_name} ${userContext.last_name}` : ''
            }
          }
        }
      };

      dispatch({
        type: ActionType.IDENTIFY_USER,
        meta
      });
    }
  };
}

export function getUserContext() {
  return (dispatch, getState) => {
    dispatch(requestUser());
    return ApiService.get('/web-api/v1/user/get')
      .then(json => dispatch(receiveUser(json)))
      .then(() => {
        // Temporarily set email for BounceX usage
        window.zola = window.zola || {};
        window.zola.tracking = {
          email: getState().user.userContext.email || ''
        };
      })
      .then(() => dispatch(identifyUser()));
  };
}

export function updateUserStatus() {
  return (dispatch) => {
    dispatch(requestUserStatus());
    return ApiService.get('/web-api/v1/user/status')
      .then(json => dispatch(receiveUserStatus(json)));
  };
}



/** WEBPACK FOOTER **
 ** ./src/actions/UserActions.js
 **/